import { InitialState, TableFilter } from "./tableFilter";
import ValuePickerFilter from "../ValuePickerFilter";

class ValuePickerFilterModel extends TableFilter {
  options = [];
  constructor(options, initialState = undefined) {
    if (initialState === undefined)
      initialState = new InitialState([...options]);
    super(ValuePickerFilter, initialState);
    this.options = options;
  }
}

export default ValuePickerFilterModel;
